import React from "react";
import { UsersIcon } from "../Dashboard/icons";
import { statusStyles } from "./data";

// A row with no value is a label next to a blank, which reads as broken
// rather than as "not captured". Zero is a value, so this cannot test
// truthiness - a lead score of 0 is real.
const hasValue = (value) =>
  value !== null && value !== undefined && value !== "";

export default function LeadInfoPanel({ conversation }) {
  if (!conversation) {
    return <section className="dash-card conv-lead-panel" />;
  }

  const lead = conversation.lead || {};
  // An unrecognised status has no palette entry, so this cannot be blind.
  const style = statusStyles[conversation.status] || {};

  const fields = [
    { label: "Email", value: lead.email },
    { label: "Phone", value: lead.phone },
    { label: "Company", value: lead.company },
    { label: "Job title", value: lead.jobTitle },
  ].filter((field) => hasValue(field.value));

  const metaFields = [
    { label: "First seen", value: lead.firstSeen },
    { label: "Source page", value: lead.sourcePage },
    { label: "UTM source", value: lead.utmSource },
    { label: "Device", value: lead.device },
    { label: "Location", value: lead.location },
  ].filter((field) => hasValue(field.value));

  const hasScore = hasValue(lead.score);
  const hasAnything =
    fields.length > 0 ||
    metaFields.length > 0 ||
    hasScore ||
    hasValue(lead.summary) ||
    conversation.status;

  return (
    <section className="dash-card conv-lead-panel">
      <div className="dash-card-header">
        <h2 className="cz-card-title">Lead info</h2>
        {/* <button type="button" className="dash-card-link conv-lead-edit">
          Edit
        </button> */}
      </div>

      {/* What they asked for, in the assistant's words. First, because the
          email and phone below it only matter once you know why. */}
      {hasValue(lead.summary) && (
        <p className="conv-lead-summary">{lead.summary}</p>
      )}

      {fields.length > 0 && (
        <dl className="conv-lead-fields">
          {fields.map((f) => (
            <div key={f.label}>
              <dt>{f.label}</dt>
              <dd>{f.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {(hasScore || conversation.status) && (
        <div className="conv-lead-score-row">
          {hasScore && (
            <div>
              <dt className="conv-lead-label">Lead score</dt>
              <span className="conv-lead-score">{lead.score}</span>
            </div>
          )}
          {conversation.status && (
            <span
              className="conv-status-badge"
              style={{ background: style.bg, color: style.color }}
            >
              {conversation.status}
            </span>
          )}
        </div>
      )}

      {metaFields.length > 0 && (
        <dl className="conv-lead-fields">
          {metaFields.map((f) => (
            <div key={f.label}>
              <dt>{f.label}</dt>
              <dd>{f.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {/* Every field was empty: say so once instead of leaving the card as a
          bare heading. */}
      {!hasAnything && (
        <p className="dash-empty">Nothing captured for this visitor yet.</p>
      )}

      {/* <div className="conv-lead-divider">
        <h3 className="cz-card-title">Qualified answers</h3>
      </div>

      <dl className="conv-lead-fields">
        {Object.entries(lead.qualified || {}).map(([label, value]) => (
          <div key={label}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>

      <button type="button" className="onboarding__btn onboarding__btn--secondary conv-convert-btn">
        <UsersIcon />
        Convert to lead
      </button> */}
    </section>
  );
}
